import React, { useEffect } from 'react';
import { Result } from 'antd';
import UIStore from '../../stores/UIStore';
import { LoginForm } from '../../components/LoginForm';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';

const RapidQuoteSuccess = () => {
    const location = useLocation();
    const history = useHistory();

    const data: any = location?.state;

    const { first_name, last_name, email, company } = data || {};

    useEffect(() => {
        window.scrollTo(0, 0);
        UIStore.setSelectedKey(['Rapid Quote']);
        UIStore.setDocumentTitle('Rapid Quote');
    }, []);

    return (
        <div className={'flex flex-col w-full'}>
            <Result
                status={'success'}
                title={'Your Quote was sent!'}
                subTitle="Thank you for using PartsBadger's Quote submission form. We will email you a quote shortly!"
            />

            {data?.isNew ? (
                <div className={'text-center'}>
                    <div className={'font-bold'}>Setup Account (Optional)</div>
                    <div
                        style={{
                            paddingTop: 5,
                            color: 'rgba(0, 0, 0, 0.45)',
                        }}
                    >
                        Complete account setup to manage quotes, orders and account requirements
                    </div>
                </div>
            ) : null}

            <div className={'w-full flex flex-row items-center justify-center'}>
                <LoginForm
                    first_name={first_name}
                    last_name={last_name}
                    email={email}
                    company={company}
                    handleLogin={() => {
                        history.push('/my-account/' + '');
                    }}
                />
            </div>
        </div>
    );
};

export default RapidQuoteSuccess;
